import React, { Fragment, useEffect, useState } from "react";
import { Button, Col, Input, Row , Select} from "antd";
import { Modal } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import plus from "../../../assets/images/pl.svg";
import ProductForm from "./productForm";
import ViewProducts from "./viewProducts";
import './style.css';
import { connect } from "react-redux";
import { clearAddOrEditProductsResponseAction, clearInitialPackageResponse, editPackageAction, getPackageProductDropdownAction, getProductsForPackageAction, initialCreatePackage } from "../../../actions/packageActions";
import { clearSingleProduct, displayCurrency } from "../../../actions";
import { toast } from "react-toastify";
import { checkDataIsEmpty } from "../../../helpers/checkDataIsEmpty";

const { Option } = Select;

const PackageForm = (props) => {
    const {initialPacakageData, onInitialPackageCreationDispatch, loading, onClearInitialPackageDispatch} = props;
    const {onGetProductsByPackageIdDispatch, reset, onClearAddOrEditProductDispatch, showForm, packageDetails, packageDropdownData, triggerPackageDropdown} = props;
    const {onClearSingleProductDispatch, onEditPackageDispatch, updateLoading, editPackageResponse, productsList} = props;
    const role = localStorage.getItem('userRole');
    const location = useLocation();
    let history = useHistory();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');
    const packageId = queryParams.get('pid');
    const createId = queryParams.get("create");

    const [show, setShow] = useState(false);
    const [open, setOpen] = useState(false);
    const [searchKey, setSearchKey] = useState(false);
    const [packageNameError, setPackageNameError] = useState("");
    const [unitPriceError, setUnitPriceError] = useState("");
    const [formData, setFormData] = useState({ articleId: '', noOfProducts: '', packageName: "", unitPrice: null });
    const [savedForm, setSavedForm] = useState({ articleId: "", packageName: "" });
    const [selectedProduct, setSelectedProduct] = useState(null);

    // The top-right slot shows the package total; the Update button only takes
    // its place once Article ID or Package Name actually differ from what is
    // stored, so there is nothing to press when there is nothing to save.
    const isDirty = (formData?.articleId ?? "") !== savedForm.articleId
        || (formData?.packageName ?? "") !== savedForm.packageName;

    const packageProducts = productsList?.packageProductResDtoList ?? [];
    const packageTotal = packageProducts.reduce((sum, item) => sum + (item?.totalPrice ?? 0), 0);

    const resetForm = (productId) => {
        setSelectedProduct(null);
        onClearSingleProductDispatch();
        if(productId) {
            setOpen(true);
            onGetProductsByPackageIdDispatch(packageId);
            onClearAddOrEditProductDispatch();
        }
    }

    const editProductByProductId = (item) => {
        history.push(`?pid=${packageId}&productId=${item?.productId}&packageProductId=${item?.packageProductId}`);
        setSelectedProduct(item);
    }

    const handleShow = () => {
        setShow(true);
        setOpen(false);
    }

    const handleClose = () => {
        onClearInitialPackageDispatch();
        setShow(false);
        setOpen(false);
        if(checkIsFromProduct()) {
            history.push(`/${role}/product`);
        } else {
            history.push(`/${role}/packages`);
        }
        setFormData({ articleId: '', noOfProducts: '', packageName: "", unitPrice: null })
        reset();
    }

    const checkIsFromProduct = () => {
        return createId === "1"
    }

    const handleChange = (e, field) => {
        const { value } = e.target;
        if(checkDataIsEmpty(value) === false) {
            setUnitPriceError("");
        } else {
            setUnitPriceError("Unit Price Required!");
        }
        setFormData({
            ...formData,
            [field]: value,
        });
    };

    const validateForm = () => {
        // Package name is the only required field
        if (checkDataIsEmpty(formData?.packageName) === true) {
            setPackageNameError("Package Name Required!");
            return false;
        }
        setPackageNameError("");
        return true;
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm() === false) {
            return;
        }

        if (packageId) {
            onEditPackageDispatch({
                packageId: packageId,
                articleId: formData.articleId,
                packageName: formData.packageName
            });
        } else {
            onInitialPackageCreationDispatch({
                articleId: formData.articleId,
                packageName: formData.packageName
            });
        }
    };


    useEffect(() => {
        if(packageId !== null && packageId !== undefined && checkDataIsEmpty(initialPacakageData?.data?.packageId)) {
            handleShow();
            onGetProductsByPackageIdDispatch(packageId);
            openTable();
        }
    },[packageId])

    useEffect(() => {
        if(loading === false) {
            if(checkDataIsEmpty(initialPacakageData?.data?.packageId) === false) {
            history.push(`?${checkIsFromProduct() ? "create=1&" : ""}id=${formData?.articleId}&pid=${initialPacakageData?.data?.packageId}`)
        }
        }
    },[loading])

    useEffect(() => {
        if(editPackageResponse) {
            toast(editPackageResponse?.data);
            // what is on screen is now what is stored — the button steps aside
            setSavedForm({ articleId: formData?.articleId ?? "", packageName: formData?.packageName ?? "" });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editPackageResponse])

    useEffect(() => {
        if(productsList) {
           setFormData({ articleId: productsList?.articleId ?? "", packageName: productsList?.packageName ?? "", unitPrice: productsList?.unitPrice })
           setSavedForm({ articleId: productsList?.articleId ?? "", packageName: productsList?.packageName ?? "" })
        }
    }, [productsList])

    useEffect(() => {
      if(showForm) {
        setShow(showForm);
      }
    }, [showForm])

    useEffect(() => {
        if(createId && checkDataIsEmpty(packageDetails) === false) {
            setFormData({ articleId: packageDetails?.articleId ?? "", packageName: packageDetails?.packageName ?? "", unitPrice: packageDetails?.unitPrice })
            setSavedForm({ articleId: packageDetails?.articleId ?? "", packageName: packageDetails?.packageName ?? "" })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createId])

    //  View Table
    const openTable = () => {
        setOpen(prev => !prev)
    }

    const handleSearchProducts = (value) => {
        setSearchKey(value);
    }

    const onArticleIdChange = (e) => {
        setFormData({ ...formData, articleId: e.target.value });
    }

    const onPackageNameChange = (e) => {
        const value = e.target.value;
        setFormData({ ...formData, packageName: value });
        if (value.trim() !== "") {
            setPackageNameError("");
        }
    }


    return (
        <Fragment>
            <button className="product-add-staffs" onClick={handleShow}>
                <img src={plus} alt="" /> Create Package
            </button>

            <Modal show={show} onHide={handleClose} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
                <div className="modal-staff">
                    <div className="head">
                        <div>
                            <i class="fas fa-arrow-left" onClick={handleClose}></i>
                            <h4>{packageId ? "Edit" : "Create"} Package</h4>
                        </div>
                    </div>
                    <div className="add-padd-top pack-add-bottom" >
                        <form className="floating-label-form" onSubmit={handleSubmit}>
                            <Row gutter={[16, 16]} align="middle">
                                <Col md={4}>
                                    <div className={'floating-label-container'}>
                                        <label className={'form-control-placeholder-pack'}>Article ID</label>
                                        <Input
                                            style={{ width: "100%" }}
                                            value={formData.articleId}
                                            onChange={onArticleIdChange}
                                            maxLength={50}
                                            placeholder="Enter article id"
                                        />
                                    </div>
                                </Col>
                                <Col md={packageId ? 10 : 16}>
                                    <div className={'floating-label-container'}>
                                        <label className={'form-control-placeholder-pack'}>Package Name <span>*</span></label>
                                        <Input
                                            style={{ width: "100%" }}
                                            value={formData.packageName}
                                            onChange={onPackageNameChange}
                                            maxLength={150}
                                            placeholder="Enter package name"
                                        />
                                        {packageNameError !== "" ? <p>{packageNameError}</p> : null}
                                    </div>
                                </Col>
                                {packageId ?
                                    <Col md={3}>
                                        <div className="pkg-stat">
                                            <span className="pkg-total-label">No. of Products</span>
                                            <span className="pkg-total-value">{packageProducts.length}</span>
                                        </div>
                                    </Col> : null}
                                {packageId ?
                                    <Col md={3}>
                                        <div className="pkg-stat pkg-stat-right">
                                            <span className="pkg-total-label">Total Price</span>
                                            <span className="pkg-total-value">{displayCurrency(packageTotal)}</span>
                                        </div>
                                    </Col> : null}
                                <Col md={4}>
                                    {/* Only enabled once Article ID or Package Name actually differ
                                        from what is stored — nothing to save otherwise. */}
                                    <Button
                                        loading={updateLoading}
                                        disabled={Boolean(packageId) && isDirty === false}
                                        htmlType="submit"
                                        className="sub-btn"
                                        block>{(id || packageId) ? "Update" : "Create"} Package</Button>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </div>
                <ViewProducts open={open || packageId} id={id} edit={editProductByProductId} reset={resetForm} productItem={selectedProduct}/>
            </Modal>
        </Fragment >
    );
}

const  mapStateToProps = (state) => {
    const {packages} = state;
    return {
        packageDropdownData: packages.packageDropdown,
        initialPacakageData: packages.initialPacakageData,
        loading: packages.loading,
        updateLoading: packages.editLoading,
        editPackageResponse: packages.editPackage,
        productsList: packages.productsList?.data,
    }
}

const mapDispatchToProps = (dispatch) => ({
    onInitialPackageCreationDispatch: (formData) => dispatch(initialCreatePackage(formData)),
    onClearInitialPackageDispatch: () => dispatch(clearInitialPackageResponse()),
    onGetProductsByPackageIdDispatch: (id) => dispatch(getProductsForPackageAction(id)),
    onClearAddOrEditProductDispatch: () => dispatch(clearAddOrEditProductsResponseAction()),
    onClearSingleProductDispatch: () => dispatch(clearSingleProduct()),
    onEditPackageDispatch: (formData) => dispatch(editPackageAction(formData)),
    triggerPackageDropdown: (searchKey) => dispatch(getPackageProductDropdownAction(searchKey))
})
export default connect(mapStateToProps, mapDispatchToProps)(PackageForm);